<template>
<w-sliding-popup ref="slidingPopup" :defaultContent="false" type="full" :title="popupHistInfo.popupTitle + ' 변경 정보'" @close="close">
  <div class="body-content" slot="content" style="height: 95%;" v-loading="isLoading">
    <div class="condition-box mr-b25">
      <span class="mr-r4">기간선택</span>
      <el-date-picker style="width:225px;" v-model="histDateRange" type="daterange" :range-separator="defaultDateRangeOptions.rangeSeparator"
        :start-placeholder="defaultDateRangeOptions.startPlaceholder" :end-placeholder="defaultDateRangeOptions.endPlaceholder"
        :default-time="defaultDateRangeOptions.defaultTime" :picker-options="defaultDateRangeOptions.pickerOptions" :clearable="false" />
      <w-device-config-help-button v-if="popupHistInfo.objCompanyName === 'ciscoSystems' && popupHistInfo.popupTitle === '장비'"></w-device-config-help-button>
      <div v-if="popupHistInfo.key !== 'INTERFACE'" class="fl-r">
        <ul class="diff-legend-box fl-l  mr-t5">
          <li><span class="item added"></span>추가</li>
          <li><span class="item modified"></span>변경</li>
          <li><span class="item deleted"></span>삭제</li>
        </ul>
        <div :span="16" align="right" class="fl-l mr-l5">
          <el-radio-group class="ordinary cmp-margin-left" v-model="diffFlag">
            <el-radio-button :label="true">변경내역만 보기</el-radio-button>
            <el-radio-button :label="false">전체 보기</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </div>
    <el-scrollbar ref="scrollbar" class="bar-visible" style="height:calc(100% - 64px);">
      <div ref="cmpWrapper" :class="$style['cmp-wrapper']" style="height:calc(99% - 64px);">
        <div class="title-bar" type="flex">
          <div class="vertical-center-box" style="width:calc(50% - 15px);">
            <span class="title-h4 dot-title mr-r10">기준 컨피그</span>
            <el-select v-model="baseHistSeq" placeholder="변경 이력 선택" @change="compareHist">
              <el-option v-for="changeInfo in checkItemHistList" :key="changeInfo.seq" :label="convertCheckDatetime(changeInfo.checkDatetime)" :value="changeInfo.seq"></el-option>
            </el-select>
            <em v-if="isEqualHist" class="mr-l10">동일한 이력입니다.</em>
          </div>
          <div class="mr-l15" style="width:50%;">
            <el-row type="flex" justify="space-between">
              <div class="vertical-center-box">
                <span class="title-h4 dot-title mr-r10">비교대상 컨피그</span>
                <el-select v-model="compareHistSeq" placeholder="변경 이력 선택" @change="compareHist">
                  <el-option v-for="changeInfo in checkItemHistList" :key="changeInfo.seq" :label="convertCheckDatetime(changeInfo.checkDatetime)" :value="changeInfo.seq"></el-option>
                </el-select>
              </div>
            </el-row>
          </div>
        </div>
        <el-row v-if="popupHistInfo.key === 'INTERFACE'" style="margin-top:-5px;" type="flex" :gutter="15">
          <el-col :span="12">
            <w-interface-change-table :interface-change-info="baseInterfaceData" />
          </el-col>
          <el-col :span="12">
            <w-interface-change-table :interface-change-info="compareInterfaceData" />
          </el-col>
        </el-row>
        <el-row v-else type="flex">
          <div style="width:100%" v-html="showCompareText"></div>
        </el-row>
      </div>
    </el-scrollbar>
  </div>
</w-sliding-popup>
</template>

<script>
import { isEmpty } from 'lodash';
import moment from 'moment';
import { faultCheckItemDefine } from '@/constants/netdevice';
import msgUtil from '@/utils/message';
import { defaultDateRangeOptions, getDateToString } from '@/utils/date';
import { isTrue } from '@/utils/boolean';
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';
import WInterfaceChangeTable from './InterfaceChangeTable';
import WDeviceConfigHelpButton from '../DeviceConfigHelpButton';

export default {
  name: 'WChangeHistPopup',
  components: {
    WInterfaceChangeTable,
    WDeviceConfigHelpButton,
  },
  props: {
    popupHistInfo: {
      type: Object,
      default: () => ({
        popupTitle: '',
      }),
    },
  },
  data() {
    return {
      defaultDateRangeOptions,
      params: {},
      histDateRange: [],
      checkItemHistList: [],
      baseHistSeq: null,
      compareHistSeq: null,
      diffFlag: false,
      compareHistData: null,
      isEqualHist: false,
      showCompareText: '',
      baseInterfaceData: [],
      compareInterfaceData: [],
      isLoading: false,
    };
  },
  watch: {
    popupHistInfo: {
      handler(val) {
        this.params.objId = val.objId;
        this.params.itemId = val.key;
        this.params.requestKey = val.key === faultCheckItemDefine.CONFIG || val.key === faultCheckItemDefine.ROUTING ? val.key.toLowerCase() : 'common';

        const endDatetime = moment(this.popupHistInfo.checkDatetime).endOf('day');
        const startDatetime = endDatetime.clone().subtract(1, 'months').startOf('day');
        this.histDateRange = [startDatetime.toDate(), endDatetime.toDate()];
      },
    },
    histDateRange: {
      handler() {
        this.params.startDatetime = this.histDateRange[0].getTime();
        this.params.endDatetime = this.histDateRange[1].getTime();
        this.loadCheckItemHist();
      },
    },
    diffFlag: {
      handler() {
        this.setShowCompareText();
      },
    },
  },
  methods: {
    /**
     * 팝업을 연다.
     * @author Ju
     * @return {[type]} [description]
     */
    open() {
      this.$refs.slidingPopup.open();
    },
    close() {
      this.$refs.scrollbar.wrap.scrollTop = 0;
    },
    /**
     * 설정한 기간 벙위에 속하는 변경 이력을 조회한다.
     * @author kimjy
     */
    loadCheckItemHist() {
      const key = this.popupHistInfo.key;
      this.params.requestKey = (key === faultCheckItemDefine.CONFIG || key === faultCheckItemDefine.ROUTING) ? key.toLowerCase() : 'common';
      this.isLoading = true;
      netdeviceInfoAPI.getNetdeviceCheckHist(this.params).then((response) => {
        if (response.data.success) {
          this.setCheckItemHist(response.data.data);
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '변경 이력', false));
          this.checkItemHistList = [];
          this.clearCompareHistData();
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '변경 이력', false));
        this.checkItemHistList = [];
        this.clearCompareHistData();
        throw new Error(e);
      }).finally(() => {
        this.isLoading = false;
      });
    },
    /**
     * 변경 이력 목록을 로드한다.
     * 선택한 장비의 '전체 점검일시' 시간에 해당하는 이력이 Left(기준 컨피그)에 선택되고
     * Right(비교대상 컨피그)는 기준 컨피그 이전 변경사항에 해당하는 대상이 선택되게 수정 ( Song - 2020. 01. 09 )
     *
     * @author kimjy
     * @param  {Object} response
     */
    setCheckItemHist(data) {
      if (!isEmpty(data)) {
        this.checkItemHistList = data;
        const targetTime = moment(this.popupHistInfo.targetCheckDatetime).format('YYYY-MM-DD HH:mm');
        const targetIndex = data.findIndex((item) => moment(item.checkDatetime).format('YYYY-MM-DD HH:mm') === targetTime && item.changed);
        // 선택한 row와 같은 시간대의 변경이력 선택
        if (data.length === 1) {
          this.compareHistSeq = this.checkItemHistList[0].seq;
          this.baseHistSeq = this.checkItemHistList[0].seq;
        } else if (targetIndex >= 0) {
          this.compareHistSeq = this.checkItemHistList[targetIndex + 1].seq;
          this.baseHistSeq = this.checkItemHistList[targetIndex].seq;
        } else {
          this.compareHistSeq = this.checkItemHistList[0].seq;
          this.baseHistSeq = this.checkItemHistList[1].seq;
        }
        this.compareHist();
      } else {
        this.clearCompareHistData();
      }
    },
    /**
     * 두 개의 변경 이력 내용을 비교한다.
     * @author kimjy
     */
    compareHist() {
      const params = {
        objId: this.params.objId,
        itemId: this.params.itemId,
        baseHistSeq: this.baseHistSeq,
        compareHistSeq: this.compareHistSeq,
        requestKey: this.params.requestKey,
      };
      this.isEqualHist = this.baseHistSeq === this.compareHistSeq;
      this.isLoading = true;
      netdeviceInfoAPI.getNetdeviceComparedData(params).then((response) => {
        if (response.data.success) {
          const data = response.data.data;
          if (!isEmpty(data)) {
            if (params.itemId === faultCheckItemDefine.INTERFACE) {
              this.setInterfaceComparedData(data);
            } else {
              this.setCommonComparedData(data);
            }
          } else {
            this.clearCompareHistData();
          }
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '변경 이력', false));
          this.clearCompareHistData();
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '변경 이력', false));
        this.clearCompareHistData();
        throw new Error(e);
      }).finally(() => {
        this.isLoading = false;
      });
    },
    /**
     * [공통] 변경 이력 비교 정보를 설정한다.
     * @author Ju
     * @param  {[type]} data [description]
     */
    setCommonComparedData(data) {
      this.baseInterfaceData = [];
      this.compareInterfaceData = [];

      this.compareHistData = data;
      this.diffFlag = isTrue(data.compareData.diffFlag);
      this.setShowCompareText();
    },
    /**
     * 비교 데이터 중 보여줄 데이터 (변경된 내용 / 전체)를 설정한다.
     * @author Ju
     */
    setShowCompareText() {
      this.showCompareText = this.diffFlag ? this.compareHistData.compareData.diff : this.compareHistData.compareData.compare;
    },
    /**
     * 인터페이스 비교 정보를 설정한다.
     * @author Ju
     * @param  {[type]} data [description]
     */
    setInterfaceComparedData(data) {
      this.showCompareText = '';
      this.baseInterfaceData = isEmpty(data.baseCheckItemHist) ? [] : JSON.parse(data.baseCheckItemHist.resultStr);
      this.compareInterfaceData = isEmpty(data.compareCheckItemHist) ? [] : JSON.parse(data.compareCheckItemHist.resultStr);
    },
    /**
     * 비교 데이터를 초기화한다.
     * @author Ju
     * @return {[type]} [description]
     */
    clearCompareHistData() {
      this.checkItemHistList = [];
      this.baseInterfaceData = [];
      this.compareInterfaceData = [];
      this.baseHistSeq = null;
      this.compareHistSeq = null;
      this.showCompareText = '';
      this.compareHistData = {};
    },
    convertCheckDatetime(value) {
      return getDateToString(value);
    },
  },
};
</script>

<style module>
.cmp-wrapper {
  height: 730px;
  padding: 4px;
  margin-top: 5px;
  width: 100%;
  /* overflow-y: auto; */
}
</style>



// WEBPACK FOOTER //
// src/views/config/group/netdevice/components/popup/ChangeHistPopup.vue